

import React from "react";

const TermsOfService = () => {
  return (
    <section className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-semibold mb-4">Terms of Service</h1>
      <p className="text-gray-700">Details about terms of service will go here.</p>
    </section>
  );
};

export default TermsOfService;
